import {inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {BasicTaDetails, FullTaDetails} from '../api';
import {TaAppStore} from '../state/clcta-store';
import {PermissionService} from './permission.service';

@Injectable({
  providedIn: 'root'
})
export class TaNavigationService {
  private store = inject(TaAppStore);
  private router = inject(Router);
  private permissionService = inject(PermissionService);

  // Opens a TA on the page that suits its status and the user's edit rights.
  open(taSubmission: FullTaDetails | BasicTaDetails): void {
    this.store.updatePreviousPageRoute(this.router.url);

    if (taSubmission.status === "InProgress") {
      if (this.permissionService.canEditTaPrimary(taSubmission)) {
        this.router.navigate([`/ta/${taSubmission.id}`]);
      } else {
        this.router.navigate([`/ta/${taSubmission.id}/view`]);
      }
    } else {
      this.router.navigate([`/ta/${taSubmission.id}/manage`]);
    }
  }
}
